import type { ManifestObject } from "@shared-core/domain/object-ui/contract";

/**
 * What an object's list or record route shows while its feature is off for the person (hide or block, Ben
 * 16 Oct): the object is built, something someone can change keeps it off here, so say that rather than
 * "not found". It reads nothing: no list, record or command call is made for a switched-off object.
 */
export function ObjectSwitchedOffPage({ object }: { object: ManifestObject }) {
  return (
    <div className="space-y-2">
      <h1 className="text-2xl font-semibold">{object.plural}</h1>
      <p className="text-muted-foreground">
        {object.label} is built but switched off in this environment.
      </p>
    </div>
  );
}
